"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var useHoneycomb_1 = (0, tslib_1.__importDefault)(require("./useHoneycomb"));
var useRequest_1 = (0, tslib_1.__importDefault)(require("./useRequest"));
var uniqueKey_1 = (0, tslib_1.__importDefault)(require("../utils/uniqueKey"));
var printTimingsAndMeta_1 = (0, tslib_1.__importDefault)(require("../utils/printTimingsAndMeta"));
var useAuth_1 = require("../auth/useAuth");
var utils_1 = require("../utils");
var usePariluxAPI = function (apiName, headersNameMap) {
    if (headersNameMap === void 0) { headersNameMap = {}; }
    var baseURL = (0, utils_1.determineBaseApiUrl)(apiName, ntConfig);
    var hcSend = (0, useHoneycomb_1.default)().hcSend;
    var request = (0, useRequest_1.default)(apiName).request;
    var _a = (0, useAuth_1.useAuth)(), getCognitoUserSessionToken = _a.getCognitoUserSessionToken, getClientId = _a.getClientId;
    var getAlternativeName = (0, react_1.useCallback)(function (nme) {
        var _a;
        return (_a = headersNameMap[nme]) !== null && _a !== void 0 ? _a : nme;
    }, [headersNameMap]);
    var pariluxRequest = (0, react_1.useCallback)(function (_a) {
        var url = _a.url, _b = _a.method, method = _b === void 0 ? 'GET' : _b, _c = _a.headers, headers = _c === void 0 ? {} : _c, params = _a.params, data = _a.data, cancelToken = _a.cancelToken;
        return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var hcTraceID, requestStartTime, res, _d, _e, _f;
            var _g, _h;
            return (0, tslib_1.__generator)(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        hcTraceID = (0, uniqueKey_1.default)();
                        hcSend("".concat(url, " ").concat(method, " Request"), hcTraceID);
                        requestStartTime = Date.now();
                        _d = request;
                        _g = {
                            url: url,
                            method: method
                        };
                        _e = [(0, tslib_1.__assign)({}, headers)];
                        _h = {};
                        _f = getAlternativeName('x-ntfos-authorization');
                        return [4 /*yield*/, getCognitoUserSessionToken()];
                    case 1: return [4 /*yield*/, _d.apply(void 0, [(_g.headers = tslib_1.__assign.apply(void 0, _e.concat([(_h[_f] = _j.sent(), _h[getAlternativeName('x-ntfos-set-clientid')] = getClientId(), _h[getAlternativeName('x-honeycomb-trace')] = "1;trace_id=".concat(hcTraceID, ",parent_id=").concat(hcTraceID), _h)])),
                                _g.params = params,
                                _g.data = data,
                                _g.cancelToken = cancelToken,
                                _g)])];
                    case 2:
                        res = _j.sent();
                        hcSend("".concat(url, " ").concat(method, " Response"), hcTraceID);
                        (0, printTimingsAndMeta_1.default)(baseURL + url, (res === null || res === void 0 ? void 0 : res.headers) || {}, requestStartTime, {
                            method: method,
                            params: params,
                            database: getClientId(),
                            honeycombTraceId: hcTraceID,
                            status: res === null || res === void 0 ? void 0 : res.status,
                        });
                        return [2 /*return*/, res];
                }
            });
        });
    }, [baseURL, request, getClientId, getCognitoUserSessionToken, hcSend]);
    return { request: pariluxRequest };
};
exports.default = usePariluxAPI;
